<template>
  <div class="page_main">
    <div class="search_block">
      <Form :label-width="90" inline>
        <FormItem label="检查时间">
          <Date-picker :value="dateValue" :clearable="false" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="请选择检查时间" @on-change="changeDate"></Date-picker>
        </FormItem>
        <FormItem label="医院机构">
          <Select placeholder="请选择" v-model="searchForm.hospitalCode" multiple @on-change="changeHospital" style="width:250px">
            <Option v-for="item in hospitalList" :value="item.organCode" :key="item.organID">{{item.organName}}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="检查科室">
          <Input placeholder="请输入" v-model="searchForm.OrganNameEN"></Input>
        </FormItem>
        <FormItem label="检查类型">
          <Input placeholder="请输入" v-model="searchForm.OrganNameEN"></Input>
        </FormItem> -->
      </Form>
      <div>
        <Button class="mr-3" @click="resetHandle">重置</Button>
        <!-- <Button  class="mr-3" type="primary" @click="aaa">导出</Button> -->
        <Button class="mr-3" type="success" @click="getData">查询</Button>
      </div>
    </div>
    <div class="big-block mb-11">
      <Tabs v-model="tabDateValue" @on-click="changeTab">
        <Tab-pane label="今天" name="1"></Tab-pane>
        <Tab-pane label="近三日天" name="2"></Tab-pane>
        <Tab-pane label="近7日" name="3"></Tab-pane>
        <Tab-pane label="30天内" name="4"></Tab-pane>
      </Tabs>
      <Tabs type="card" value="name1">
        <Tab-pane label="报告数据" name="name1">
          <Steps :current="4">
            <Step>
              <div class="step-title" slot="title">院内报告数据</div>
              <div class="step-content" slot="content">
                报告总量<span>{{hospitalReportNumberCount}}</span>
                <div class="difference">{{hospitalReportNumberCount==iBoxReportNumberCount?'无差异':'差异：'+(hospitalReportNumberCount-iBoxReportNumberCount)}}</div>
              </div>
              <div class="step-icon" slot="icon">2</div>
            </Step>
            <Step>
              <div class="step-title" slot="title">I-BOX报告数据</div>
              <div class="step-content" slot="content">
                已校对总量<span>{{iBoxReportNumberCount}}</span>
                <div class="difference">{{cloudReportNumberCount==iBoxReportNumberCount?'无差异':'差异：'+cloudReportNumberCount-iBoxReportNumberCount}}</div>
              </div>
              <div class="step-icon" slot="icon">1</div>
            </Step>
            <Step>
              <div class="step-title" slot="title">云平台报告数据</div>
              <div class="step-content" slot="content">
                已校对总量<span>{{cloudReportNumberCount}}</span>
              </div>
              <div class="step-icon" slot="icon">3</div>
            </Step>
            
          </Steps>
        </Tab-pane>
        <Tab-pane label="影像数据" name="name2">
          <Steps :current="4">
            <Step>
              <div class="step-title" slot="title">院内报告数据</div>
              <div class="step-content" slot="content">
                报告总量<span>{{hospitalReportNumberCount2}}</span>
                <div class="difference">{{hospitalReportNumberCount2==iBoxReportNumberCount2?'无差异':'差异：'+(hospitalReportNumberCount2-iBoxReportNumberCount2)}}</div>
              </div>
              <div class="step-icon" slot="icon">2</div>
            </Step>
            <Step>
              <div class="step-title" slot="title">I-BOX报告数据</div>
              <div class="step-content" slot="content">
                已校对总量<span>{{iBoxReportNumberCount2}}</span>
                <div class="difference">{{cloudReportNumberCount2==iBoxReportNumberCount2?'无差异':'差异：'+cloudReportNumberCount2-iBoxReportNumberCount2}}</div>
              </div>
              <div class="step-icon" slot="icon">1</div>
            </Step>
            <Step>
              <div class="step-title" slot="title">云平台报告数据</div>
              <div class="step-content" slot="content">已校对总量<span>{{cloudReportNumberCount2}}</span></div>
              <div class="step-icon" slot="icon">3</div>
            </Step>
          </Steps>
        </Tab-pane>
      </Tabs>
    </div>
    <div class="big-block">
      <Table
        :loading="loading"
        border
        width='100%'
        stripe :columns="columns"
        :data="dataList"
        size="small"
        disabled-hover
        highlight-row
        ></Table>
        <!-- :height="500" -->
    </div>
    <Modal
      v-model="modalShow"
      width="900"
      title="数据明细"
      :footer-hide="true"
      
    >
    <div class="fx-sw-cen mb-10">
      <div class="fx-row-cen block-out">
        <div v-for="item in hospitaModallList" :key="item.hospitalCode">{{item.hospitalName}}</div>
        <div v-for="item in examTypeModalList" :key="item.examTypeCode">{{item.examTypeName}}</div>
      </div>
      <Button type="success" @click="exportHandle">导出</Button>
    </div>
    <Table
      border
      width='100%'
      stripe 
      :height="500"
      :columns="modalColumns"
      :data="modalList"
      size="small"
      disabled-hover
      highlight-row
    >
    </Table>
    <div class="tr">
      <Page
        class="mt-2"
        :total="total"
        :page-size-opts="[10,20,50]"
        :current="pageIndex"
        :page-size="pageSize"
        show-elevator
        show-sizer
        show-total
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
      />
    </div>
    </Modal>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const toDay=dayjs().format('YYYY-MM-DD')
export default {
  data(){
    return{
      tabDateValue:'1',
      total:0,
      pageSize:10,
      pageIndex:1,
      searchForm:{
        hospitalCode:[],
        startDate:toDay,
        endDate:toDay
      },
      loading:false,
      dataList:[],
      columns:[
        { title: "医疗机构", key: "hospitalName", align: 'center',},
        {
          title: "报告数据", 
          align: 'center',
          children:[
            { title: "医院报告总量", key: "hospitalReportNumberCount", align: 'center',
              render: (h, params)=>{
                return h("div",[
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      style: {
                        color:'#2D8DF0'
                      },
                      on: {
                        click: () => {
                          this.toDetail(params.row,1,1);
                        },
                      },
                    },
                    params.row.hospitalReportNumberCount
                  )
                ])
              }
            },
            { title: "I-BOX报告总量", key: "iBoxReportNumberCount", align: 'center',
              render: (h, params)=>{
                if(params.row.iBoxReportNumberCount!=params.row.hospitalReportNumberCount){
                  return h("div",[
                    h(
                      "Button",
                      {
                        props: {
                          type: "text",
                          size: "small",
                        },
                        style: {
                          color:'#2D8DF0'
                        },
                        on: {
                          click: () => {
                            this.toDetail(params.row,1,2);
                          },
                        },
                      },
                      params.row.iBoxReportNumberCount
                    )
                  ])
                }else{
                  return h("div",{},params.row.iBoxReportNumberCount)
                }
              }
            },
            { title: "云平台报告总量", key: "cloudReportNumberCount", align: 'center',
              render: (h, params)=>{
                if(params.row.hospitalReportNumberCount!=params.row.cloudReportNumberCount){
                  return h("div",[
                    h(
                      "Button",
                      {
                        props: {
                          type: "text",
                          size: "small",
                        },
                        style: {
                          color:'#2D8DF0'
                        },
                        on: {
                          click: () => {
                            this.toDetail(params.row,1,3);
                          },
                        },
                      },
                      params.row.cloudReportNumberCount
                    )
                  ])
                }else{
                  return h("div",{},params.row.cloudReportNumberCount)
                }
              }
            },
          ]
        },
        {
          title: "影像数据", 
          align: 'center',
          children:[
            { title: "医院报告总量", key: "hospitalReportNumberCount2", align: 'center',
              render: (h, params)=>{
                return h("div",[
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      style: {
                        color:'#2D8DF0'
                      },
                      on: {
                        click: () => {
                          this.toDetail(params.row,2,1);
                        },
                      },
                    },
                    params.row.hospitalReportNumberCount
                  )
                ])
              }
            },
            { title: "I-BOX报告总量", key: "iBoxReportNumberCount2", align: 'center',
              render: (h, params)=>{
                if(params.row.iBoxReportNumberCount2!=params.row.hospitalReportNumberCount2){
                  return h("div",[
                    h(
                      "Button",
                      {
                        props: {
                          type: "text",
                          size: "small",
                        },
                        style: {
                          color:'#2D8DF0'
                        },
                        on: {
                          click: () => {
                            this.toDetail(params.row,2,2);
                          },
                        },
                      },
                      params.row.iBoxReportNumberCount2
                    )
                  ])
                }else{
                  return h("div",{},params.row.iBoxReportNumberCount2)
                }
              }
            },
            { title: "云平台报告总量", key: "cloudReportNumberCount2", align: 'center',
              render: (h, params)=>{
                if(params.row.hospitalReportNumberCount2!=params.row.cloudReportNumberCount2){
                  return h("div",[
                    h(
                      "Button",
                      {
                        props: {
                          type: "text",
                          size: "small",
                        },
                        style: {
                          color:'#2D8DF0'
                        },
                        on: {
                          click: () => {
                            this.toDetail(params.row,2,3);
                          },
                        },
                      },
                      params.row.cloudReportNumberCount2
                    )
                  ])
                }else{
                  return h("div",{},params.row.cloudReportNumberCount2)
                }
              }
            },
          ]
        }

      ],
      modalShow:false,
      modalColumns:[
      {
        title: "序号",
        key: "",
        type: "index",
        width: "60",
        align: "center"
      },
      { title: "医疗机构", key: "hospitalName", align: 'center'},
      { title: "患者姓名", key: "patientName", align: 'center'},
      { title: "性别", key: "patientSex", align: 'center'},
      { title: "患者类型", key: "patientTypeName", align: 'center'},
      { title: "检查编号", key: "accessionNumber", align: 'center'},
      // { title: "科室", key: "hospitalName", align: 'center'},
      { title: "检查类型", key: "examType", align: 'center'},
      { title: "检查项目", key: "examItem", align: 'center'},
      { title: "检查时间", key: "examDate", align: 'center'},
      ],
      modalList:[],
      detailForm:{},
      dateValue:[new Date(),new Date()],
      examTypeModalList:[],
      hospitaModallList:[]
    }
  },
  activated(){
    this.getData()
  },
  computed:{
    hospitalReportNumberCount(){
      return this.dataList.reduce((pre,next)=>{return pre+next.hospitalReportNumberCount},0)
    },
    hospitalReportNumberCount2(){
      return this.dataList.reduce((pre,next)=>{return pre+next.hospitalReportNumberCount2},0)
    },
    iBoxReportNumberCount(){
      return this.dataList.reduce((pre,next)=>{return pre+next.iBoxReportNumberCount},0)
    },
    iBoxReportNumberCount2(){
      return this.dataList.reduce((pre,next)=>{return pre+next.iBoxReportNumberCount2},0)
    },
    cloudReportNumberCount(){
      return this.dataList.reduce((pre,next)=>{return pre+next.cloudReportNumberCount},0)
    },
    cloudReportNumberCount2(){
      return this.dataList.reduce((pre,next)=>{return pre+next.cloudReportNumberCount2},0)
    },
    hospitalList(){
      return this.$store.state.hospitalList
    }
  },
  methods:{
    changeTab(val){
      console.log(val)
      if(val==1){
        this.dateValue=[new Date(),new Date()]
      } else if(val==2){
        this.dateValue=[new Date().getTime() - 3600 * 1000 * 24 * 3,new Date()]
      } else if(val==3){
        this.dateValue=[new Date().getTime() - 3600 * 1000 * 24 * 7,new Date()]
      } else if(val==3){
        this.dateValue=[new Date().getTime() - 3600 * 1000 * 24 * 30,new Date()]
      }
      this.searchForm.startDate=dayjs(this.dateValue[0]).format('YYYY-MM-DD')
      this.searchForm.endDate=dayjs(this.dateValue[1]).format('YYYY-MM-DD')
      this.getData()
    },
    async getData(){
      // 报告数据
      let res = await this.$api.post('/datastatistics/GetCorrectReportData',this.searchForm)
      console.log(res)
      // 影像数据
      let res2 = await this.$api.post('/datastatistics/GetCorrectImageData',this.searchForm)
      console.log(res2)
      if (res != false && res2 != false) {
        this.dataList = res.data.map((item,index)=>{
          return {
            ...item,
            cloudReportNumberCount2:res2.data[index].cloudReportNumberCount,
            hospitalReportNumberCount2:res2.data[index].hospitalReportNumberCount,
            iBoxReportNumberCount2:res2.data[index].iBoxReportNumberCount,
          }
        })
        console.log(this.dataList)
      }
    },
    exportHandle(){
      var urls ="/datastatistics/GetCorrectStream?";
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.detailForm);
      let url = baseUrl + urls + params;
      console.log(url);
      window.open(url);
      // this.$api.post('/datastatistics/GetCorrectStream',this.detailForm).then(res=>{
      //   console.log(res)
      //   if(res!=false){
          
      //   }
      // })
    },
    resetHandle(){
        this.searchForm.hospitalCode=[]
        this.searchForm.startDate=toDay
        this.searchForm.endDate=toDay
        this.dateValue=[new Date(),new Date()]
        this.tabDateValue="1"
    },
    toDetail(row,dataType,dataItem){
      // 
      // console.log(row)
      this.$api.post('/datastatistics/GetCorrectDataDetailType',{
        startDate:this.searchForm.startDate,
        endDate:this.searchForm.endDate,
        hospitalCode:row.hospitalCode,
        dataItem,
        dataType
      }).then(res=>{
        if(res){
          this.examTypeModalList=res.data.examTypeList
          this.hospitaModallList=res.data.hospitalList
        }
      })
      this.detailForm={
        startDate:this.searchForm.startDate,
        endDate:this.searchForm.endDate,
        hospitalCode:row.hospitalCode,
        dataType,
        dataItem,
      }
      this.modalList=[]
      this.modalShow=true
      this.pageIndex=1
      this.getDetailList()
    },
    getDetailList(){
      this.$api.post('/datastatistics/GetCorrectDataDetail',{
        ...this.detailForm,
        pageSize:this.pageSize,
        pageIndex:this.pageIndex
      }).then(res=>{
        console.log(res)
        if(res!=false){
          this.total=res.data.dataCount
          this.modalList=res.data.list
        }
      })
    },
    //分页
    pageChange: function (page) {
      this.pageIndex = page;
      this.getDetailList();
    },
    sizeChange: function (size) {
      this.pageSize = size;
      this.getDetailList();
    },
    changeDate(val){
      this.searchForm.startDate=val[0]
      this.searchForm.endDate=val[1]
    },
    changeHospital(){

    }
  }
}
</script>

<style scoped lang="less">
// .my-steps{
//   position: relative;
//   .difference{
//     position: absolute;
//   }
// }
.block-out{
  >div{
    font-size: 13px;
    color: #18BE6B;
    padding: 7px 16px;
    border-radius: 4px;
    border: 1px solid #18BE6B;
    margin-right: 16px;
  }
}
/deep/.ivu-steps .ivu-steps-tail{
  top:24px
}
.step-title{
  font-size: 21px;
  color: #333333;
  line-height: 43px;
}
.step-content{
  font-size: 16px;
  color: #666666;
  margin-left: 15px;
  position: relative;
  .difference{
    position: absolute;
    z-index: 100;
    top: 10px;
    font-size: 21px;
    color: #2D8DF0;
    left: 50%;
  }
  span{
    font-size: 32px;
    color: #2D8DF0;
    margin-left: 5px;
  }
}
.step-icon{
  font-size: 19px;
  line-height: 43px;
  width: 43px;
  height: 43px;
  border-radius: 50%;
  border: 1px solid #2d8cf0;
}
// /depp/.ivu-steps-head-inner{
//   height: 43px!important;
//   width: 43px;
// }
.tr{
  text-align: right;
}
.mb-10{
  margin-bottom: 10px;
}
/deep/.ivu-btn-text{
  span{
    text-decoration:underline
  }
}
  .big-block{
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 3px 16px 0px rgba(114,141,186,0.06);
  }
  .mb-11{
    margin-bottom: 11px;
  }
</style>